export type GetStringFunction<T> = (key: keyof T) => string

/**
 * makeGetStringFunction returns a function to return a UI string for a given key
 * @param {Strings} strings - An object containing string definitions
 * @returns {StringFunction} A function that will return a string for a given key
 */
export function makeGetStringFunction<T extends Record<string, string>>(
  strings: T
): GetStringFunction<T> {
  return (key) => strings[key]
}
